module.exports = __webpack_public_path__ + "img/Dr Lo Photo 1.fedb19c3.webp";